import { z } from 'zod'

export const orderActionSchema = z.enum([
  'send-invoice',
  'resend-invoice',
  'edit-order',
  'cancel-order',
  'process-orders',
])
export type OrderAction = z.infer<typeof orderActionSchema>

export function orderActionMeta(orderAction: OrderAction) {
  return { orderAction }
}
